import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Category Services
export const createCategoryAdminService = (data) => {
  return http.post(`${base_url}/admin/Category`, data);
};
export const getCategoriesAdminService = (data) => {
  return http.get(`${base_url}/admin/categories`, data);
};
export const editCategoryAdminService = (data) => {
  return http.put(`${base_url}/admin/category/${data.id}`, data);
};
export const deleteCategoryAdminService = (id) => {
  return http.delete(`${base_url}/admin/category/${id}`);
};
// End Category

// Start Sub Category
export const createSubCategoryAdminService = (data) => {
  return http.post(`${base_url}/admin/subcategory`, data);
};
export const getSubCategoriesAdminService = (params) => {
  return http.get(`${base_url}/admin/subcategories`, { params });
};
export const editSubCategoryAdminService = (data) => {
  return http.put(`${base_url}/admin/subcategory/${data.id}`, data);
};
export const deleteSubCategoryAdminService = (id) => {
  return http.delete(`${base_url}/admin/subcategory/${id}`);
};
// End Sub Category

// Start Menu
export const createMenuAdminService = (data) => {
  return http.post(`${base_url}/admin/menu`, data);
};
export const getMenusAdminService = (data) => {
  return http.get(`${base_url}/admin/menus`, data);
};
export const editMenuAdminService = (data) => {
  return http.put(`${base_url}/admin/menu/${data.id}`, data);
};
export const deleteMenuAdminService = (id) => {
  return http.delete(`${base_url}/admin/menu/${id}`);
};
// End Menu

// Start User
export const getUsersAdminService = (params) => {
  return http.get(`${base_url}/admin/users`, { params });
};
export const createUserAdminService = (data) => {
  return http.post(`${base_url}/admin/user`, data);
};
export const editUserAdminService = (data) => {
  return http.put(`${base_url}/admin/user/${data.id}`, data);
};
export const changeUserConfirmAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/confirm`);
};
export const changeUserPasswordAdminService = (data) => {
  return http.patch(`${base_url}/admin/user/${data.id}/change-password`, data);
};
export const deleteUserAdminService = (id) => {
  return http.delete(`${base_url}/admin/user/${id}`);
};
// End User

// End Image
export const editImageAdminService = (data) => {
  return http.put(`${base_url}/admin/image`, data);
};
// End Image

// Start Setting
export const editSettingAdminService = (data) => {
  return http.put(`${base_url}/admin/setting`, data);
};
// End Setting
